import React from "react"
import Stepper from "react-stepper-horizontal"
import PropTypes from "prop-types"

const ProgressBar = ({ activeStep }) => {
  const steps = [
    { title: "Patient" },
    { title: "Caregiver" },
    { title: "Insurance" },
    { title: "Scheduling" },
  ]
  return (
    <Stepper
      activeColor="#122F4E"
      activeStep={activeStep}
      activeTitleColor="#6987CA"
      completeBarColor="#FFC156"
      completeColor="#FFC156"
      completeTitleColor="#6987CA"
      defaultBorderColor="#FFC156"
      defaultColor="#FFC156"
      steps={steps}
    />
  )
}
ProgressBar.propTypes = {
  activeStep: PropTypes.number.isRequired,
}
export default ProgressBar
